import React, { useState } from 'react'
import { Upload } from 'antd'
import { PlusOutlined, LoadingOutlined } from '@ant-design/icons'
import { getAuthHeaders } from '@/utils/session'

const UploadBase = props => {
  const { uploadProps, onChange, value } = props
  const [loading, setloading] = useState(false)
  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  )
  const handleCHange = info => {
    onChange(info)
    if (info.file.status === 'uploading') {
      setloading(true)
      return
    }
    if (info.file.status === 'done') {
      setloading(false)
    }
  }
  return (
    <Upload {...uploadProps} headers={getAuthHeaders()} onChange={handleCHange}>
      {value ? <img src={value || ''} alt="" className="avatar imgSrc" /> : uploadButton}
    </Upload>
  )
}
export default UploadBase
